/*
 * @Author: along longwang6@163.com
 * @Date: 2025-06-16 20:19:55
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-16 20:37:43
 * @FilePath: /ehr-web/src/constants/cookies.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export enum CookiesKey {
  TOKEN = 'ehr_token',
}
